/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachPlanTaskRequestDto
 */
export interface AttachPlanTaskRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AttachPlanTaskRequestDto
     */
    taskId: string;
    /**
     * Catalog trigger id for this plan line
     * @type {string}
     * @memberof AttachPlanTaskRequestDto
     */
    triggerId: string;
    /**
     * 1-based order; appended at the end when omitted
     * @type {number}
     * @memberof AttachPlanTaskRequestDto
     */
    sequence?: number;
}

/**
 * Check if a given object implements the AttachPlanTaskRequestDto interface.
 */
export function instanceOfAttachPlanTaskRequestDto(value: object): value is AttachPlanTaskRequestDto {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('triggerId' in value) || value['triggerId'] === undefined) return false;
    return true;
}

export function AttachPlanTaskRequestDtoFromJSON(json: any): AttachPlanTaskRequestDto {
    return AttachPlanTaskRequestDtoFromJSONTyped(json, false);
}

export function AttachPlanTaskRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachPlanTaskRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'],
        'triggerId': json['triggerId'],
        'sequence': json['sequence'] == null ? undefined : json['sequence'],
    };
}

export function AttachPlanTaskRequestDtoToJSON(json: any): AttachPlanTaskRequestDto {
    return AttachPlanTaskRequestDtoToJSONTyped(json, false);
}

export function AttachPlanTaskRequestDtoToJSONTyped(value?: AttachPlanTaskRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'triggerId': value['triggerId'],
        'sequence': value['sequence'],
    };
}

